// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"485":"f2121dec","529":"458ad79f"}[chunkId] + ".chunk.js";
};